import React from 'react'
import PropTypes from 'prop-types'
import { useLocalization } from '@contexts/LocalizationContext'
import { message } from 'antd'
import FormComponent from './Form'
import { client } from '@utils/client'
import { useHistory } from 'react-router-dom'
import Modal from '@components/Modal'

const Create = (props) => {
  const { setModalCreateOpen, modalCreateOpen, defaultValue } = props
  const { t } = useLocalization()
  const history = useHistory()
  const handleSubmit = async (data) => {
    data.availableSince = data.availableSinceToUntil[0].format('YYYY-MM-DD')
    data.availableUntil = data.availableSinceToUntil[1].format('YYYY-MM-DD')
    data.usableSince = data.usableSinceToUntil[0].format('YYYY-MM-DD')
    data.usableUntil = data.usableSinceToUntil[1].format('YYYY-MM-DD')

    delete data.availableSinceToUntil
    delete data.usableSinceToUntil

    setModalCreateOpen(false)
    try {
      await client.post('/reward', data)
      message.success('สำเร็จ')
      history.push('/rewards-list')
    } catch (e) {
      console.log(e)
      message.error('ไม่สำเร็จ')
    }
  }

  return (
    <>
      <Modal
        maxHeight={700}
        bodyStyle={{ padding: '0px  0px 0px 16px' }}
        borderRadius
        centered={true}
        title={t('rewards.list.listScreen.create')}
        open={modalCreateOpen}
        onCancel={() => setModalCreateOpen(false)}
        maskClosable={false}
        footer={null}
      >
        <FormComponent
          handleSubmit={handleSubmit}
          doStatus="create"
          defaultValues={defaultValue}
          modalCreateOpen={modalCreateOpen}
          onCancel={() => setModalCreateOpen(false)}
        />
      </Modal>
    </>
  )
}

Create.propTypes = {
  setModalCreateOpen: PropTypes.func,
  modalCreateOpen: PropTypes.bool,
  defaultValue: PropTypes.any,
}

export default Create
